import { BookOpenIcon, EyeIcon, DumbbellIcon, type LucideIcon } from 'lucide-react';

export interface MethodStep {
  n: string;
  title: string;
  icon: LucideIcon;
  text: string;
  bgClass: string;
  iconClass: string;
}

export const methodSteps: MethodStep[] = [
  {
    n: '1',
    title: 'Abre',
    icon: BookOpenIcon,
    text: 'Elige una sesión del calendario o el aspecto que quieres trabajar: técnica, táctica, preparación física o gestión del equipo.',
    bgClass: 'bg-naranja-pale',
    iconClass: 'text-naranja-strong'
  },
  {
    n: '2',
    title: 'Mira',
    icon: EyeIcon,
    text: 'Consulta el objetivo, el montaje, los tiempos y los esquemas. Las sesiones completas se presentan en dos páginas imprimibles, con correcciones y opciones de adaptación.',
    bgClass: 'bg-azul-light',
    iconClass: 'text-azul'
  },
  {
    n: '3',
    title: 'Entrena',
    icon: DumbbellIcon,
    text: 'Ajusta la propuesta al grupo y al espacio disponible. Lleva la ficha a pista, observa la respuesta de tus jugadores y aplica la variante que necesiten.',
    bgClass: 'bg-naranja-pale',
    iconClass: 'text-naranja-strong'
  }
];
